import React from 'react';

import {
  CmButton,
  CmHeading,
  CmList,
  CmListItem,
  CmModal,
  CmModalBody,
  CmModalFooter,
  CmText,
  CmUnorderedList,
} from '@/components/uiParts';
import { CustomGroup } from '@/pages/link-items/LinkItemsPage';

interface Props {
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  handleUpdateLinkedGroupItems: (e: React.FormEvent) => void;
  linkedGroups: CustomGroup[];
}

export const RegisterConfirmModal: React.FC<Props> = ({
  isOpen,
  linkedGroups,
  onClose,
  handleUpdateLinkedGroupItems,
}) => {
  const displayGroupName = (
    isTentativeDelete: boolean,
    inputGroupName?: string,
    editGroupName?: string,
    group_name?: string
  ) => {
    if (isTentativeDelete) {
      // NOTE 削除するときに編集後のeditGroupNameが表示をされると違和感であるため分岐で処理を分けている。
      return inputGroupName ?? group_name;
    }

    return editGroupName ?? inputGroupName ?? group_name;
  };
  return (
    <CmModal {...{ isOpen, onClose }} title="品切れ登録の確認">
      <CmModalBody>
        <CmList spacing="3" mt="2">
          {linkedGroups.map((group, index) => {
            const {
              inputGroupName,
              editGroupName,
              group_name,
              isTentativeDelete = false,
              linked_store_items,
            } = group;
            return (
              <CmListItem key={index} pb="5px" borderBottom="1px solid gray">
                <CmHeading display="flex" alignItems="center">
                  <CmText>
                    {displayGroupName(
                      isTentativeDelete,
                      inputGroupName,
                      editGroupName,
                      group_name
                    )}
                  </CmText>
                  {isTentativeDelete && (
                    <CmText fontSize="md" color="red">
                      （削除対象）
                    </CmText>
                  )}
                </CmHeading>
                {!isTentativeDelete &&
                  linked_store_items.map((item) => {
                    const { item_name, delivery_service_name } = item;

                    return (
                      <CmUnorderedList mt="1" key={item.item_name}>
                        <CmListItem>
                          {item_name}（{delivery_service_name}）
                        </CmListItem>
                      </CmUnorderedList>
                    );
                  })}
              </CmListItem>
            );
          })}
        </CmList>
      </CmModalBody>
      <CmModalFooter>
        {/*
         // @ts-ignore TS2590 */}
        <CmButton onClick={handleUpdateLinkedGroupItems}>登録</CmButton>
        <CmButton ml="3" onClick={onClose} variant="outline">
          閉じる
        </CmButton>
      </CmModalFooter>
    </CmModal>
  );
};
